import {Component, OnInit} from '@angular/core';
import {TreeNode} from 'primeng/primeng';
import {UserQualificationsService} from "../../services/user-qualifications.service";
import {ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SetLevelComponent} from "../set-level/set-level.component";
import {UserService} from "../../../../../services/user.service";
import {User} from "../../../../../models/user.model";

@Component({
  selector: 'app-qualifications-list',
  templateUrl: './qualifications-list.component.html',
  styleUrls: ['./qualifications-list.component.css']
})
export class QualificationsListComponent implements OnInit {

  selection = [];
  data: TreeNode[];
  nodes: TreeNode[] = [];
  isLoaded = false;

  isAdmin = false;
  isHead = false;
  private user: User;

  nodesCopy: any[] = [];
  nodesFiltered: any[] = [];
  nodesOriginal: any[] = [];
  nodesTemp: TreeNode[] = [];
  nodesFilteredWithParents: TreeNode[] = [];

  nodePath: number[] = [];
  nodePathMap: Map<number[], string> = new Map();

  isFiltered: false;

  constructor(public qualificationsServ: UserQualificationsService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private userService: UserService
  ) {
  }

  ngOnInit() {
    this.getUserRole();
    this.getQualifications();
    this.qualificationsServ.clearNodeSelection();
    this.qualificationsServ.userId = this.route.snapshot.params['id'];
  }

  getUserRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
  }

  getQualifications() {
    this.qualificationsServ.getUserQualifications(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 204) {
          this.qualificationsServ.noQualifications = true;
          this.isLoaded = true;
        }
        if (response.status === 200) {
          this.qualificationsServ.setNodes(response.body);
          this.nodesOriginal = response.body;
          this.nodesCopy = this.nodesOriginal;
          if (this.nodesCopy.length < 1) {
            this.qualificationsServ.noQualifications = true;
          } else {
            this.qualificationsServ.noQualifications = false;
          }
          this.qualificationsServ.getQualificationsError = false;
          this.isLoaded = true;
        }
      },
      (error) => {
        if (error.status === 502) {
          this.qualificationsServ.getQualificationsError = true;
          this.isLoaded = true;
        }
        if (error.status === 500) {
          this.qualificationsServ.getQualificationsError = true;
          this.isLoaded = true;
        }
      }
    );
  }

  nodeSelect(event) {
    this.qualificationsServ.selectedNode = event.node;
    this.qualificationsServ.nodeId = event.node.data.id;
    this.qualificationsServ.nodeName = event.node.data.name;
    this.qualificationsServ.nodeType = event.node.data.type;
    this.qualificationsServ.nodeLevel = event.node.data.level;
    this.qualificationsServ.nodeDate = event.node.data.date;
  }

  nodeUnselect() {
    this.selection = [];
    this.qualificationsServ.clearNodeSelection();
  }

  open() {
    const modalRef = this.modalService.open(SetLevelComponent);
  }

  filterByLevel() {
    this.isFiltered = <false>!this.isFiltered;
    this.nodesFiltered = [];
    if (this.isFiltered) {

      this.nodesFiltered = [];
      this.nodesTemp = [];
      this.nodesFilteredWithParents = [];

      if (this.nodesOriginal.length > 0) {
        this.nodesOriginal.forEach(groupNode => {
          const t = [];
          this.nodePath = t;
          this.nodePath.push(this.nodesOriginal.indexOf(groupNode));
          this.startSearch(groupNode);
        });
      }

      this.nodesCopy = this.nodesFiltered;
      this.nodesCopy.forEach(c => {
      });
    } else {
      this.nodesCopy = this.nodesOriginal;
    }
  }

  searchNode(groupNode) {
    if (groupNode.children) {
      this.startSearch(groupNode);
    } else {
      if (groupNode.data.level) {
        const tmpPath = this.nodePath;
        this.nodePathMap.set(tmpPath, groupNode.data.name);
        this.nodesFiltered.push(groupNode);
      }
    }
  }

  startSearch(grpNode) {
    if (grpNode.children) {
      grpNode.children.forEach(childNode => {
        this.nodePath.push(grpNode.children.indexOf(childNode));
        this.searchNode(childNode);
      });

    } else {
      if (grpNode.data.level) {
        const tmpPath = this.nodePath;
        this.nodePathMap.set(tmpPath, grpNode.data.name);
        this.nodesFiltered.push(grpNode);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/qualifications/components/qualifications-list/qualifications-list.component.ts